<div [formGroup]="fg" class="col-s-12">
  <div class="rule-inputs col-s-12" [formGroupName]="'timePeriod'">
    <div class="mat-custom-input">
      <!-- Read-only: the dropdown does not open at all, matching the other selects on the rule pages. -->
      <mat-form-field
        [appPreventClickInViewMode]="isViewOnly"
        [ngClass]="{ 'custom-opacity cursor-not-allowed': isViewOnly }"
        appearance="fill"
        floatLabel="always"
        class="col-s-12"
      >
        <mat-label>Time Unit</mat-label>
        <mat-select
          panelClass="earn-rules-select-panel"
          disableOptionCentering
          formControlName="unit"
          [disabled]="isViewOnly"
          (selectionChange)="onUnitsChange()"
          placeholder="Select time unit"
        >
          @for (option of expirationUnits; track option) {
          <mat-option [value]="option">
            {{ option | titlecase }}
          </mat-option>
          }
        </mat-select>
        <mat-error> This field is mandatory </mat-error>
      </mat-form-field>
    </div>

    <div class="mat-custom-input">
      <mat-form-field
        [ngClass]="{ 'custom-disabled': isViewOnly }"
        appearance="fill"
        floatLabel="always"
        class="col-s-12"
      >
        @if (fg.get('timePeriod')?.get('unit')?.value) {
        <mat-label>{{
          'Number Of ' + fg.get('timePeriod')?.get('unit')?.value + 's'
            | titlecase
        }}</mat-label>
        } @if (!fg.get('timePeriod')?.get('unit')?.value) {
        <mat-label>Number of Units</mat-label>
        }
        <!-- <mat-label>Time Unit</mat-label> -->
        <input
          matInput
          type="text"
          inputmode="numeric"
          formControlName="value"
          [readonly]="isViewOnly"
          (keypress)="preventNonNumericalInput($event)"
          (blur)="onStripLeadingZeros($event)"
        />
        @if (fg.get('timePeriod')?.get('value')?.hasError('required')) {
        <mat-error> This field is mandatory </mat-error>
        } @else if (fg.get('timePeriod')?.get('value')?.hasError('pattern') ||
        fg.get('timePeriod')?.get('value')?.hasError('min') ||
        fg.get('timePeriod')?.get('value')?.hasError('error')) {
        <mat-error> Enter a valid whole number greater than 0 </mat-error>
        } @else if (fg.get('timePeriod')?.get('value')?.hasError('max')) {
        <mat-error> Enter a value between 1 and 1000 </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
</div>
